import { analyticService } from 'global/services';

// faq-social-icon

// data-to


const trackIconsClick = (nodeList) => {
    if (!nodeList.length) return null;
    nodeList.forEach((node) => {
        node.addEventListener('click', () => {
            analyticService.push({
                eventName: 'Button_FAQ_Click',
                button_name: node.dataset.to,
            });
        });
    });
    return null;
};

export function registerFAQAreaEvents() {
    const faqNodeList = document.querySelectorAll('#faq-button');

    trackIconsClick(document.querySelectorAll('#faq-social-icon'));

    if (faqNodeList.length) {
        faqNodeList.forEach((node) => {
            const header = node.querySelector('.faqRowButton');
            const cutElement = node.querySelector('.faqRowCut');
            // Клик на заголовок - переключаем аккордеон
            header.addEventListener('click', () => {
                if (!node.classList.contains('open')) {
                    analyticService.push({
                        eventName: 'Open_FAQ_toggle',
                        question_num: node.dataset.serial,
                    });
                }

                const currentlyOpen = Array.from(faqNodeList).find(
                    (el) => el.classList.contains('open'),
                );

                if (currentlyOpen && currentlyOpen !== node) {
                    currentlyOpen.classList.remove('open');
                }

                node.classList.toggle('open');
            });

            // Клик на контент (кроме ссылок) - закрываем аккордеон
            cutElement.addEventListener('click', (event) => {
                if (!event.target.closest('a')) {
                    node.classList.remove('open');
                }
            });
        });
    }
}
